import { ValidatorFn, Validators } from '@angular/forms';
import { ValidationProvider } from '@services/helpers/validation.service';
import { FileData, GeneralAction } from '@models/models';

export interface Brands {
	actions: BrandsActions;
	authCompanyId: number;
	brands: Array<BrandsListItem>;
}

export interface BrandsActions {
	UPGRADE_PLAN: GeneralAction;
	SIGN_IN: GeneralAction;
	ADD_NEW_BRAND: GeneralAction;
}

export interface BrandDetailsActions {
	UPDATE_BRAND_DATA: GeneralAction;
	TURN_OFF_GDPR_FEATURES: GeneralAction;
	TURN_ON_GDPR_FEATURES: GeneralAction;
	DELETE_BRAND_LOGO: GeneralAction;
	PREVIEW_BRAND_LOGO: GeneralAction;
	UPDATE_BRAND_LOGO: GeneralAction;
	DELETE_BRAND_BANNER: GeneralAction;
	PREVIEW_BRAND_BANNER: GeneralAction;
	UPDATE_BRAND_BANNER: GeneralAction;
	DELETE_BRAND: GeneralAction;
	PREVIEW_BRAND_FOR_UPDATE: GeneralAction;
}

export interface BrandsListItem {
	action: BrandsActions;
	companyId: number;
	companyName: string;
	logoUrl: string;
	selected: boolean;
}

export interface Action {
	actionName?: string;
	method?: string;
	url?: string;
	logoUrl: string;
	selected: boolean;
}

export interface BrandCreationData {
	name: string;
	email: string;
	toImportData?: BrandCreationImportData;
	companyId?: number;
}

export interface BrandCreationImportData {
	sourceCompanyId: number;
	types: Array<string>;
}

export interface BrandImportPreview {
	brandsDataToImport: Array<BrandImportPreviewData>;
}

export interface BrandImportPreviewData {
	companyId: number;
	name: string;
	availableDataToImport: ImportAction;
}

export interface ImportAction {
	[prop: string]: {
		label: string;
		group: string;
	};
}

export interface Checkbox {
	title: string;
	isChecked: boolean;
	controlName: string;
	children: Array<Checkbox>;
}

export interface BrandList {
	brands: Array<BrandDetailsInfo>;
	actions: BrandsActions;
}

export interface BrandsDetails {
	brandInfo: BrandDetailsInfo;
	logo: BrandMediaItem;
	clientPortalBanner: BrandMediaItem;
	gdprFeatures: BrandGDPR;
}

export interface BrandDetailsInfo {
	name: string;
	number: string;
	address: string;
	city: string;
	state: string;
	postcode: string;
	country: string;
	phone: string;
	email: string;
	logoUrl?: string;
	companyId?: number;
	actions: BrandDetailsActions;
}

export interface BrandMediaItem {
	url: string;
	actions: BrandDetailsActions;
}

export interface BrandGDPR {
	enabled: boolean;
	actions: BrandDetailsActions;
}

export interface BrandInputItem {
	name: string;
	type: string;
	placeholder: string;
	formControlName: string;
	validators: Array<ValidatorFn>;
}

export interface SettingsOverviewData {
	brandSettings: Array<SettingsOverviewSection>;
}

export interface SettingsOverviewSection {
	name: string;
	brand: string;
	logoUrl: string;
	companyId: string;
	actions: {
		[prop: string]: GeneralAction;
	};
	settings: {
		[prop: string]: GeneralAction;
	};
}

export interface SettingsOverview {
	companySettings: Array<SettingsOverviewListItem>;
	globalSettings: Array<SettingsOverviewListItem>;
	brandName?: string;
	actions?: {
		[prop: string]: GeneralAction;
	};
	currentCompanyId?: number | string;
	logoUrl?: string;
}

export interface SettingsOverviewListItem {
	title: string;
	icon: string;
	url: string;
	name?: string;
	description?: string;
	actionDescription?: string;
	dataSection?: string;
}

export const BRAND_EDIT_FORM: Array<BrandInputItem> = [
	{
		name: 'Company Name',
		type: 'text',
		placeholder: 'Enter your business name e.g. Peter Phong Photography',
		formControlName: 'name',
		validators: [Validators.required, ValidationProvider.noWhitespaceValidator]
	},
	{
		name: 'Business Number',
		type: 'text',
		placeholder: 'Enter your ABN, Rn or CRN',
		formControlName: 'number',
		validators: []
	},
	{
		name: 'Street Address',
		type: 'text',
		placeholder: 'Enter your street address',
		formControlName: 'address',
		validators: []
	},
	{
		name: 'City/Suburb',
		type: 'text',
		placeholder: 'Enter your city or suburb',
		formControlName: 'city',
		validators: []
	},
	{
		name: 'State/Country',
		type: 'text',
		placeholder: 'Enter your state or county"',
		formControlName: 'state',
		validators: []
	},
	{
		name: 'Postcode/Zip',
		type: 'text',
		placeholder: 'Enter your postcode or zip code',
		formControlName: 'postcode',
		validators: []
	},
	{
		name: 'Country',
		type: 'text',
		placeholder: 'Enter your country',
		formControlName: 'country',
		validators: []
	},
	{
		name: 'Phone Number',
		type: 'text',
		placeholder: 'Enter your contact number e.g. +61 432 567 890',
		formControlName: 'phone',
		validators: []
	},
	{
		name: 'Company Email',
		type: 'email',
		placeholder: 'Enter your email e.g. info@peterphong.com',
		formControlName: 'email',
		validators: [
			Validators.required,
			ValidationProvider.emailValidator,
			ValidationProvider.noWhitespaceValidator
		]
	}
];

export interface UpdateEditMediaResponse {
	data: UpdateEditMediaResponseData;
	result: string;
}

export interface UpdateEditMediaResponseData {
	actions: BrandDetailsActions;
}

export interface GetEditMediaResponse {
	data: FileData;
	result: string;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./shared/models/brands.model.ts